import type { PaletteOptions } from '@material-ui/core/styles/createPalette'

export const basePalette = {
  /** Semantic Colors */
  primary: {
    light: '#DA777E',
    main: '#F04649',
    dark: '#B3212B',
    contrastText: '#FFFFFF',
    gradientStart: '#ED4A67',
    gradientEnd: '#F04649',
  },
  info: {
    light: '#52B7FF',
    main: '#0076CB',
    dark: '#164B54',
  },
  success: {
    light: '#48D3AB',
    main: '#00B485',
    dark: '#00663E',
    contrastText: '#FFFFFF',
  },
  error: {
    light: '#DA777E',
    main: '#E52021',
    dark: '#A80005',
  },
  warning: {
    light: '#F0DFBA',
    main: '#F5C364',
    dark: '#E57E45',
  },
  /** Colors */
  blue: {
    lighter: '#97D4FF',
    light: '#52B7FF',
    main: '#0076CB',
    dark: '#164B54',
    darker: '#002E6C',
  },
  green: {
    light: '#48D3AB',
    main: '#00B485',
    dark: '#00663E',
  },
  purple: {
    light: '#7B7FA3',
    main: '#2E3042',
    dark: '#1A1D20',
  },
  red: {
    lighter: '#F6B7BE',
    light: '#DA777E',
    main: '#F04649',
    dark: '#B3212B',
  },
  yellow: {
    light: '#F0DFBA',
    main: '#F5C364',
    dark: '#E57E45',
  },
  gray: {
    light: '#E9E9E9',
    main: '#D9D9D9',
    dark: '#9D9D9D',
  },
  white: {
    main: '#FFFFFF',
  },
}

const muiPaperDefault = '#FFFFFF'
export const popoverPalette = {
  type: 'light',
  /** Semantic Colors */
  primary: {
    main: '#4E65E8',
  },
  secondary: {
    main: '#1F285D',
  },
  background: {
    default: '#F3F5F7',
  },
  surface: {
    light: muiPaperDefault,
    main: muiPaperDefault,
    dark: muiPaperDefault,
  },
} satisfies PaletteOptions

export const adminLightPalette = {
  type: 'light',
  /** Semantic Colors */
  secondary: {
    light: '#7B7FA3',
    main: '#2E3042',
    dark: '#1A1D20',
  },
  surface: {
    light: '#FEFEFE',
    main: '#ECF0F1',
    dark: '#2E3042',
  },
} satisfies PaletteOptions

export const adminDarkPalette = {
  type: 'dark',
  /** Semantic Colors */
  secondary: {
    light: '#7B7FA3',
    main: '#FFFFFF',
  },
  surface: {
    light: '#141414',
    main: '#222222',
    dark: '#333333',
  },
} satisfies PaletteOptions

export const dataVizPalette = {
  data: {
    blue: {
      light: '#A5BBFF',
      main: '#6B82FE',
      dark: '#5F6FE6',
    },
    peach: {
      light: '#E69999',
      main: '#FF7061',
      dark: '#DC5D56',
    },
    pink: {
      light: '#D08CB2',
      main: '#BC5090',
      dark: '#A04383',
    },
    purple: {
      light: '#978CCE',
      main: '#58508D',
      dark: '#1B1B51',
    },
    marigold: {
      light: '#ECBE70',
      main: '#ECA33A',
      dark: '#E28A30',
    },
    teal: {
      light: '#5FCFD2',
      main: '#1AB0AF',
      dark: '#1E938F',
    },
  },
}
